import React from 'react';
import { Card, Skeleton } from 'antd';

const ShopCardSkeleton = () => {
    return (
        <Card
            className="shop-card-premium"
            cover={
                <div className="pcu-h-200 pcu-overflow-hidden pcu-flex-center pcu-bg-muted" style={{ position: 'relative' }}>
                     <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '12px',
                        width: '80px',
                        height: '80px',
                        opacity: 0.3
                    }}>
                        <div style={{ background: '#ddd', borderRadius: '8px' }}></div>
                        <div style={{ background: '#ddd', borderRadius: '50%' }}></div>
                        <div style={{ background: '#ddd', borderRadius: '50%' }}></div>
                        <div style={{ background: '#ddd', borderRadius: '8px' }}></div>
                    </div>
                    <Skeleton.Node active style={{ position: 'absolute', width: '100%', height: '100%', opacity: 0 }} />
                </div>
            }
        >
            <div className="shop-card-content" style={{ padding: '15px' }}>
                <Skeleton active paragraph={{ rows: 1, width: '90%' }} title={{ width: '60%' }} />
                <div className="pcu-margin-top-15">
                    <Skeleton.Button active block shape="default" style={{ height: 35, borderRadius: 6 }} />
                </div>
            </div>
        </Card>
    );
};

export default ShopCardSkeleton;
